var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonSecondary',{attrs:{"isDisabled":_vm.handleIsButtonDisabled,"text":_vm.buttonText,"type":_vm.handleButtonType},nativeOn:{"click":function($event){return _vm.handleButtonClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }